import { render, staticRenderFns } from "./getpass.vue?vue&type=template&id=fcc39dec&scoped=true"
import script from "./getpass.vue?vue&type=script&lang=js"
export * from "./getpass.vue?vue&type=script&lang=js"
import style0 from "./getpass.vue?vue&type=style&index=0&id=fcc39dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc39dec",
  null
  
)

export default component.exports